import { Button } from 'rsuite';
import React, { Dispatch, SetStateAction } from 'react';
import { FormModal } from '../../common/FormModal';
import { useObjectField } from '../../common/useObjectField';
import TrainerModalContent from './TrainerModalContent';

type Props = {
  modalTrainerObject?: {
    id: string;
    slug: string;
    title: string;
    titleEn: string;
    titleDe: string;
    name: string;
    nameEn: string;
    nameDe: string;
    description: string;
    descriptionEn: string;
    descriptionDe: string;
    shortDescription?: string;
    shortDescriptionEn?: string;
    shortDescriptionDe?: string;
    priority?: number;
    active: boolean;
    isFeatured: boolean;
  };
  handleModalClose: () => void;
  setModalTrainerObject: Dispatch<
    SetStateAction<{
      id: string;
      slug: string;
      title: string;
      titleEn: string;
      titleDe: string;
      name: string;
      nameEn: string;
      nameDe: string;
      description: string;
      descriptionEn: string;
      descriptionDe: string;
      shortDescription?: string;
      shortDescriptionEn?: string;
      shortDescriptionDe?: string;
      priority?: number;
      active: boolean;
      isFeatured: boolean;
    }>
  >;
  submit: () => Promise<void>;
  errorSummary?: string[];
};

export default function EditTrainerModal({
  modalTrainerObject,
  setModalTrainerObject,
  handleModalClose,
  submit,
  errorSummary = [],
}: Props) {
  const setTitle = useObjectField(
    modalTrainerObject,
    setModalTrainerObject,
    'title'
  );
  const setTitleEn = useObjectField(
    modalTrainerObject,
    setModalTrainerObject,
    'titleEn'
  );
  const setTitleDe = useObjectField(
    modalTrainerObject,
    setModalTrainerObject,
    'titleDe'
  );
  const setSlug = useObjectField(
    modalTrainerObject,
    setModalTrainerObject,
    'slug'
  );
  const setActive = useObjectField(
    modalTrainerObject,
    setModalTrainerObject,
    'active'
  );
  const setFeatured = useObjectField(
    modalTrainerObject,
    setModalTrainerObject,
    'isFeatured'
  );
  const setName = useObjectField(
    modalTrainerObject,
    setModalTrainerObject,
    'name'
  );
  const setNameEn = useObjectField(
    modalTrainerObject,
    setModalTrainerObject,
    'nameEn'
  );
  const setNameDe = useObjectField(
    modalTrainerObject,
    setModalTrainerObject,
    'nameDe'
  );
  const setDescription = useObjectField(
    modalTrainerObject,
    setModalTrainerObject,
    'description'
  );
  const setDescriptionEn = useObjectField(
    modalTrainerObject,
    setModalTrainerObject,
    'descriptionEn'
  );
  const setDescriptionDe = useObjectField(
    modalTrainerObject,
    setModalTrainerObject,
    'descriptionDe'
  );
  const setShortDescription = useObjectField(
    modalTrainerObject,
    setModalTrainerObject,
    'shortDescription'
  );
  const setShortDescriptionEn = useObjectField(
    modalTrainerObject,
    setModalTrainerObject,
    'shortDescriptionEn'
  );
  const setShortDescriptionDe = useObjectField(
    modalTrainerObject,
    setModalTrainerObject,
    'shortDescriptionDe'
  );
  const setPriority = useObjectField(
    modalTrainerObject,
    setModalTrainerObject,
    'priority'
  );

  return (
    <FormModal
      open={!!modalTrainerObject}
      onClose={handleModalClose}
      title="Редагувати Тренера"
      errorSummary={errorSummary}
      footer={
        <>
          <Button onClick={submit} appearance="primary">
            Зберегти
          </Button>
          <Button onClick={handleModalClose} appearance="subtle">
            Скасувати
          </Button>
        </>
      }
    >
      {modalTrainerObject && (
        <TrainerModalContent
          modalTrainerTitle={modalTrainerObject.title}
          modalTrainerTitleEn={modalTrainerObject.titleEn}
          modalTrainerTitleDe={modalTrainerObject.titleDe}
          modalTrainerSlug={modalTrainerObject.slug}
          modalTrainerName={modalTrainerObject.name}
          modalTrainerActive={modalTrainerObject.active}
          modalTrainerFeatured={modalTrainerObject.isFeatured}
          modalTrainerDescription={modalTrainerObject.description}
          modalTrainerNameEn={modalTrainerObject.nameEn}
          modalTrainerNameDe={modalTrainerObject.nameDe}
          modalTrainerDescriptionEn={modalTrainerObject.descriptionEn}
          modalTrainerDescriptionDe={modalTrainerObject.descriptionDe}
          modalTrainerShortDescription={modalTrainerObject.shortDescription}
          modalTrainerShortDescriptionEn={modalTrainerObject.shortDescriptionEn}
          modalTrainerShortDescriptionDe={modalTrainerObject.shortDescriptionDe}
          modalTrainerPriority={modalTrainerObject.priority}
          setModalTrainerTitle={setTitle}
          setModalTrainerTitleEn={setTitleEn}
          setModalTrainerTitleDe={setTitleDe}
          setModalTrainerSlug={setSlug}
          setModalTrainerActive={setActive}
          setModalTrainerFeatured={setFeatured}
          setModalTrainerName={setName}
          setModalTrainerNameEn={setNameEn}
          setModalTrainerNameDe={setNameDe}
          setModalTrainerDescription={setDescription}
          setModalTrainerDescriptionEn={setDescriptionEn}
          setModalTrainerDescriptionDe={setDescriptionDe}
          setModalTrainerShortDescription={setShortDescription}
          setModalTrainerShortDescriptionEn={setShortDescriptionEn}
          setModalTrainerShortDescriptionDe={setShortDescriptionDe}
          setModalTrainerPriority={setPriority}
        />
      )}
    </FormModal>
  );
}
